export default {
  selectedOptionColor: Styles.color.grey.three,
  selectionOptionsSeparatorColor: Styles.color.grey.five,
  checkIconFillColor: Styles.color.grey.five,
  selectionOptionsRequiredBackgroundColor: Styles.color.red,
};
